import CustomFooter from './CustomFooter';

const FooterComponent = () => {
  return <CustomFooter />;
};

export default FooterComponent;
